import { LayoutDashboard, Globe, MousePointerClick, CalendarClock, Headphones, WifiOff } from 'lucide-react';

const features = [
    {
        icon: LayoutDashboard,
        title: "Dashboard Unificado",
        description: "Gerencie múltiplas telas e localidades a partir de um único painel de controle intuitivo na nuvem."
    },
    {
        icon: Globe,
        title: "Gerenciamento Remoto",
        description: "Atualize seu conteúdo de qualquer lugar, a qualquer hora, usando seu computador, smartphone ou tablet."
    },
    {
        icon: MousePointerClick,
        title: "Interface Intuitiva",
        description: "Nossa plataforma foi desenhada para ser simples. Comece a usar em minutos."
    },
    {
        icon: CalendarClock,
        title: "Conteúdo Contextual",
        description: "Programe mídias por horário, dia da semana ou em resposta a eventos para um engajamento máximo."
    },
    {
        icon: Headphones,
        title: "Suporte Humanizado",
        description: "Conte com nossa equipe de especialistas para te ajudar a extrair o máximo da plataforma."
    },
    {
        icon: WifiOff,
        title: "Reprodução Offline",
        description: "Seu conteúdo continua rodando mesmo sem internet. O player armazena a programação localmente para garantir exibição ininterrupta."
    }
];

export const LandingTechFeatures = () => {
    return (
        <section className="py-24 bg-white overflow-hidden">
            <div className="max-w-[1440px] mx-auto px-6">
                <div className="mb-16">
                    <h2 className="text-4xl lg:text-5xl font-black text-gray-900 mb-6 max-w-3xl">
                        Tecnologia de Ponta para <span className="text-primary">Resultados Reais</span>
                    </h2>
                    <p className="text-xl text-gray-500 max-w-2xl font-medium">
                        Uma plataforma robusta com funcionalidades que simplificam sua operação e maximizam seu impacto.
                    </p>
                </div>

                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {features.map((feature, index) => (
                        <div key={index} className="group p-8 rounded-[32px] border border-gray-100 bg-gray-50/50 hover:bg-white hover:shadow-2xl hover:border-gray-200 transition-all duration-300">
                            <div className="w-14 h-14 bg-white rounded-2xl shadow-sm flex items-center justify-center mb-6 text-gray-900 group-hover:bg-primary group-hover:text-white transition-colors">
                                <feature.icon className="w-7 h-7" />
                            </div>
                            <h3 className="text-xl font-black text-gray-900 mb-3">{feature.title}</h3>
                            <p className="text-gray-500 font-medium leading-relaxed group-hover:text-gray-600">
                                {feature.description}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};
